export default __webpack_public_path__ + "static/media/R5No4.d0c91155.mp3";